import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '../..';

interface Props {
  onChange: (e: any) => void;
  value: string;
  name?: string;
  label?: string;
  exclude?: string[];
  [x: string]: any;
}

export const SelectTransactionType = (props: Props) => {
  const { onChange, value, name, label, exclude, ...rest } = props;
  const translate = useTranslate();
  const t = (key: string) => translate(SelectTransactionType.l(key));

  return (
    <SelectInput
      label={label || t('operationType')}
      options={SelectTransactionType.getChoices(translate, false, exclude) as any}
      onChange={onChange}
      value={value || ''}
      name={name || 'operationType'}
      {...rest}
    />
  );
};
SelectTransactionType.l = (key: string): string =>
  `components.TransactionsHistory.cellComponents.OperationTypeField.${key}`;
SelectTransactionType.getChoices = (
  translate: (str: string) => string,
  forReactAdmin = true,
  exclude: string[] = []
) => {
  const t = (key: string) => translate(SelectTransactionType.l(key));
  const choices = [
    { value: '', text: t('any') },
    {
      value: 'P2P_TRANSFER',
      text: t('P2P_TRANSFER'),
    },
    { value: 'PURCHASE', text: t('PURCHASE') },
    { value: 'BILL_PAYMENT', text: t('BILL_PAYMENT') },
    { value: 'TOP_UP', text: t('TOP_UP') },
    { value: 'CASH_DEPOSIT', text: t('CASH_DEPOSIT') },
    { value: 'CASH_WITHDRAWAL', text: t('CASH_WITHDRAWAL') },
    { value: 'OWN_ACCOUNTS_TRANSFER', text: t('OWN_ACCOUNTS_TRANSFER') },
    { value: 'PAYOUT', text: t('PAYOUT') },
    { value: 'REMITTANCE', text: t('REMITTANCE') },
    { value: 'REMITTANCE_PAYOUT', text: t('REMITTANCE_PAYOUT') },
    { value: 'REVERSAL', text: t('REVERSAL') },
    { value: 'REFUND', text: t('REFUND') },
    { value: 'SERVICE_CHARGE', text: t('SERVICE_CHARGE') },
    { value: 'SETTLEMENT', text: t('SETTLEMENT') },
    { value: 'LOYALTY_TRANSFER', text: t('LOYALTY_TRANSFER') },
    { value: 'WRITE_OFF', text: t('WRITE_OFF') },
    { value: 'ACCOUNT_TRANSFER', text: t('ACCOUNT_TRANSFER') },
    { value: 'FORCED_APPROVAL', text: t('FORCED_APPROVAL') },
    { value: 'INCOMING_TRANSFER', text: t('INCOMING_TRANSFER') },
    { value: 'CURRENCY_CONVERSION', text: t('CURRENCY_CONVERSION') },
    { value: 'CASH_COLLECTION', text: t('CASH_COLLECTION') },
    { value: 'CARD_TRANSACTION', text: t('CARD_TRANSACTION') },
    { value: 'DIRECT_TRANSFER', text: t('DIRECT_TRANSFER') },
    { value: 'INVITATION_TRANSFER', text: t('INVITATION_TRANSFER') },
    { value: 'DEBIT_ORDER', text: t('DEBIT_ORDER') },
    { value: 'VOUCHER_REDEMPTION', text: t('VOUCHER_REDEMPTION') },
    { value: 'CURRENCY_CONVERSION_PROFIT', text: t('CURRENCY_CONVERSION_PROFIT') },
    { value: 'TENANT_FEE', text: t('TENANT_FEE') },
    { value: 'ACQUIRING_FEE', text: t('ACQUIRING_FEE') },
  ]
    .filter((item) => !exclude.includes(item.value))
    .sort((a, b) => {
      if (!a.value) return -1;
      if (!b.value) return 1;
      return a.text.localeCompare(b.text);
    });
  return forReactAdmin ? choices.map((item) => ({ id: item.value, name: item.text })) : choices;
};

// Each consumer below excludes the operation types that don't make sense at ITS level
// (e.g. a type that only ever applies to a Transfer leg or Balance Transaction, not to
// the whole Head Transaction/Deal, or a type excluded for that consumer's own business
// reasons). The lists intentionally aren't shared — a type excluded for one consumer
// may still be valid for another.

export const HEAD_TRANSACTIONS_EXCLUDED_OPERATION_TYPES = [
  'LOYALTY_TRANSFER',
  'ACQUIRING_FEE',
  'CURRENCY_CONVERSION_PROFIT',
  'CURRENCY_CONVERSION',
];
export const DEALS_EXCLUDED_OPERATION_TYPES = [
  'LOYALTY_TRANSFER',
  'ACQUIRING_FEE',
  'CURRENCY_CONVERSION_PROFIT',
  'CURRENCY_CONVERSION',
];
export const FX_MAPPING_EXCLUDED_OPERATION_TYPES = [
  'LOYALTY_TRANSFER',
  'ACQUIRING_FEE',
  'CURRENCY_CONVERSION_PROFIT',
  'CURRENCY_CONVERSION',
];
export const REWARD_EXCLUDED_OPERATION_TYPES = [
  'LOYALTY_TRANSFER',
  'ACQUIRING_FEE',
  'CURRENCY_CONVERSION_PROFIT',
  'CURRENCY_CONVERSION',
];
